import { MayNull } from '@apeiron/temp'
import { useLazyQuery } from '@apollo/client'
import { rewardInfoSchema } from '@src/deserialize/yup/reward'
import graphql from '@src/graphql/query/getClaimableRewardTypeInfosByRewardName'
import { RewardInfo } from '@src/types/reward'
import * as R from 'ramda'
import { useCallback, useState } from 'react'

const useGetClaimableRewardTypeInfosByRewardName = (): Hook => {
  const [doFetch, { refetch: doRefetch }] = useLazyQuery(graphql)

  const [data, setData] = useState<Response>(null)

  const fetch = useCallback(
    async (assetNames: Request): Promise<Response> => {
      const variables = {
        name: assetNames
      }

      const response = await doFetch({ variables })

      const result = R.pathOr(
        [],
        ['data', 'getClaimableRewardTypeInfosByRewardName'],
        response
      )

      const reward = R.map(
        item => rewardInfoSchema.cast(item) as RewardInfo,
        result
      )

      setData(reward)

      return reward
    },
    [doFetch]
  )

  const refetch = useCallback(async () => {
    doRefetch()
  }, [doRefetch])

  return {
    data,
    fetch,
    refetch
  }
}

type Request = string | string[]

type Response = MayNull<RewardInfo[]>

type Hook = {
  data: Response
  fetch: (assetNames: Request) => Promise<Response>
  refetch: () => void
}

export default useGetClaimableRewardTypeInfosByRewardName
